<div bsModal #newsatisfactionchoice="bs-modal" id="newsatisfactionchoice" class="modal fade" (onShown)="onShown()"  role="dialog" aria-labelledby="newsatisfactionchoice" aria-hidden="true" [config]="{backdrop: 'static'}">
    <div class="modal-dialog">

        <div #modalContent class="modal-content">
            <div class="modal-header text-center">
                <button type="button" class="close" (click)="close()" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
                <h2 class="modal-title text-center"><span class="capitalize">{{action}}</span> satisfaction choice</h2>
            </div>

            <div class="modal-body">
                <div class="row">
                    <div class="col-12">
                        <label>Language:</label>
                        <select #languageShortCode id="satisfaction_languages" (change)="checkData(languageShortCode.value)">
                            <option *ngFor="let language of languages" [value]="language.ShortCode">{{language.Name}}</option>
                        </select>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12">
                        <label>Text:</label>
                        <textarea (focusout)="addLocalization(text.value, languageShortCode.value)" 
                                  (keypress)="preventSpace(text.value, $event)"
                                  (keyup)="preventSpace(text.value, $event)"
                                  id="textareaChoice" class="" #text placeholder="Question body" cols="2" rows="2">{{text}}</textarea>
                    </div>
                </div>

                <div class="row">
                    <h6><b>Points</b></h6>
                </div>

                <div class="row">
                    <label>Positively keyed</label>
                    <input (keypress)="preventLetters($event)" (keyup)="preventSpace(text.value, $event)" type="number" min="0" name="name" value="{{positiveP}}" id="positive" />
                </div>

                <div class="row">
                    <label>Negatively keyed</label>
                    <input (keypress)="preventLetters($event)" (keyup)="preventSpace(text.value, $event)" type="number" min="0" name="name" value="{{negativeP}}" id="negative" />
                </div>
            </div>

            <div class="modal-footer text-right">
                <input (click)="close()" type="button" class="btn" name="close" value="Cancel" />

                <ng-container>
                    <input type="button" (click)="saveQuestion(text.value)" class="btn btn-primary waves-effect" value="Save" />
                </ng-container>
            </div>
        </div>
    </div>
</div>
